import React, { useState, useEffect } from 'react';
import { ErrorFunction } from './ErrorFunctionConstants';
import { useParams } from 'react-router-dom';
import {ErrorConstants,systemConfiguration } from '../../CommonImports';


const GlobalError = () => {
      const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
      const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
      const [errorMssg, seterrorCodeMssg] = useState("");           //error mssg like ---> ERR_NETWORK / ERR_BAD_REQUEST
      const [errorCode, seterrorCode] = useState("");               // code generate ----> 400


     useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const errorMssg = params.get("errorMssg");
        const errorCode = params.get("errorCode");
        seterrorCodeMssg(errorMssg);
        seterrorCode(errorCode);
     }, []);

    return (
        
        <div style={{textAlign:"center",fontFamily:"Helvetica",color:"#333"}}>
           {ErrorConstants.NETWORK_ERROR_CODE===errorMssg?(
            
            
            // <p>{ErrorConstants.NETWORK_ERROR_PUBLIC_MSG}</p>
            
               <div>
               <img width="500px" height="500px" src={mediaUrl + "maintenance-icon.jpg?" + sasToken} ></img>
               <h1 style={{fontSize: "5vw;"}}>We’ll be back soon!</h1>
                  <p style={{fontSize: "1.5em;"}}>
                  Sorry for the inconvenience but we’re performing some maintenance at the moment. If you need to you can always
                  <a style={{color: "#dc8100", textDecoration: "none"}} href="/ContactUs" > contact us </a>,
                  otherwise we’ll be back online shortly!
                  {/* <br/><a style={{color: "#dc8100", textDecoration: "none"}} href="/GLogin" > Click here to navigate to Login Page. </a>, */}
                  </p>
                  <p>— The GLearnTech Team.</p>
               </div>
              
          
           ):
           errorMssg===ErrorConstants.ERR_BAD_REQUEST_CODE && errorCode===400 ?(
            <div>
            <img width="500px" height="500px" src="/images/GLearnTech/maintenance-icon.jpg" ></img>
            <h1 style={{fontSize: "5vw;"}}>Bad request Observed!</h1>
               <p style={{fontSize: "1.5em;"}}>
               Sorry for the inconvenience but we’ve observed bad request. please clear cookies and try after sometime. If you need to you can always
               <a style={{color: "#dc8100", textDecoration: "none"}} href="/ContactUs" > contact us </a>,
               if you observed continuosly!
               {/* <br/><a style={{color: "#dc8100", textDecoration: "none"}} href="/GLogin" > Click here to navigate to Login Page. </a>, */}
               </p>
               <p>— The GLearnTech Team.</p>
            </div>
            //   <p>{ErrorConstants.ERR_BAD_REQUEST_PUBLIC_MSG}</p>
           ):
           errorMssg===ErrorConstants.ERR_BAD_RESPONSE_CODE && errorCode===500?(
            <div>
            <img width="500px" height="500px" src="/images/GLearnTech/maintenance-icon.jpg" ></img>
            <h1 style={{fontSize: "5vw;"}}>Bad response Observed!</h1>
               <p style={{fontSize: "1.5em;"}}>
               Sorry for the inconvenience but we’ve observed bad response. please clear cookies and try after sometime. If you need to you can always
               <a style={{color: "#dc8100", textDecoration: "none"}} href="/ContactUs" > contact us </a>,
               if you observed continuosly!
               {/* <br/><a style={{color: "#dc8100", textDecoration: "none"}} href="/GLogin" > Click here to navigate to Login Page. </a>, */}
               </p>
               <p>— The GLearnTech Team.</p>
            </div>
            // <p>{ErrorConstants.ERR_BAD_RESPONSE_PUBLIC_MSG}</p>
           ):
           errorMssg===503?(
            <div>
            <img width="500px" height="500px" src="/images/GLearnTech/maintenance-icon.jpg" ></img>
            <h1 style={{fontSize: "5vw;"}}>System encounter error!</h1>
               <p style={{fontSize: "1.5em;"}}>
               Sorry for the inconvenience but we’ve observed system error in response. please clear cookies and try after sometime. If you need to you can always
               <a style={{color: "#dc8100", textDecoration: "none"}} href="/ContactUs" > contact us </a>,
               if you observed continuosly!
               {/* <br/><a style={{color: "#dc8100", textDecoration: "none"}} href="/GLogin" > Click here to navigate to Login Page. </a>, */}
               </p>
               <p>— The GLearnTech Team.</p>
            </div>
            // <p>Generic error :{errorMssg}</p>
           )
          :(
            <div>
            <img width="500px" height="500px" src="/images/GLearnTech/maintenance-icon.jpg" ></img>
            <h1 style={{fontSize: "5vw;"}}>Observed malfunction in the request!</h1>
               <p style={{fontSize: "1.5em;"}}>
               Sorry for the inconvenience but we’ve observed malfunction in the request. please clear cookies and try after sometime. If you need to you can always
               <a style={{color: "#dc8100", textDecoration: "none"}} href="/ContactUs" > contact us </a>,
               if you observed continuosly!
               {/* <br/><a style={{color: "#dc8100", textDecoration: "none"}} href="/GLogin" > Click here to navigate to Login Page. </a>, */}
               </p>
               <p>— The GLearnTech Team.</p>
            </div>
         //   <p>System Cannot find the Specified Path</p>
           )
           }
                       
        </div>
    )

}
export default GlobalError;

